module.exports = __webpack_public_path__ + "static/media/header_slide_03.60c3fe71.jpg";